import React, { memo, useState } from "react";

function CategoriaCard({ sec, fotoPortada, onClick }) {
  const imagenNoValida =
    !fotoPortada ||
    fotoPortada.includes("via.placeholder.com") ||
    fotoPortada.trim() === "";

  const [imagenFallida, setImagenFallida] = useState(imagenNoValida);

  const inicialCategoria = sec ? sec.charAt(0).toUpperCase() : "M";

  return (
    <div
      onClick={onClick}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "7px",
        cursor: "pointer",
        flexShrink: 0,
        width: "78px",
      }}
    >
      <div
        style={{
          width: "66px",
          height: "66px",
          borderRadius: "50%",
          padding: "3px",
          boxSizing: "border-box",
          background:
            "linear-gradient(135deg, #111 0%, #5c3b1e 45%, #c89b5a 100%)",
          boxShadow: "0 5px 14px rgba(0,0,0,0.12)",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            backgroundColor: "#fff7ec",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            boxSizing: "border-box",
          }}
        >
          {imagenFallida ? (
            <div
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                background: "linear-gradient(135deg, #fff7ec 0%, #f2dfc8 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#6b3f19",
                fontSize: "24px",
                fontWeight: "950",
                letterSpacing: "-0.5px",
              }}
            >
              {inicialCategoria}
            </div>
          ) : (
            <img
              src={fotoPortada}
              alt={sec}
              loading="lazy"
              decoding="async"
              onError={() => setImagenFallida(true)}
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                objectFit: "cover",
                display: "block",
              }}
            />
          )}
        </div>
      </div>

      <span
        style={{
          fontSize: "11px",
          fontWeight: "900",
          color: "#111",
          textAlign: "center",
          maxWidth: "78px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          lineHeight: "1.2",
        }}
        title={sec}
      >
        {sec}
      </span>
    </div>
  );
}

export default memo(CategoriaCard);
